import React from "react";
import { FaStar } from "react-icons/fa";

const HistoryVideo = ({video, socket, cookies}) => {

    let prestigeCount = 100;

    const onQueue = () => {
        socket.emit('queueVideo', {videoID: video.videoID, title: video.title, queuedBy: cookies['rave_username']});
    }

    return (
        <div className='QueuedVideo'>
            {video.count < prestigeCount && <p className='playIndicator' style={{float: 'right', 'margin-right': '4px'}}>{video.count}</p>}
            {video.count >= prestigeCount && <FaStar className='playIndicator' style={{float: 'right', 'margin-right': '4px', 'padding-bottom':'4px'}} />}
            <table><tr>
                <td><img src={"https://img.youtube.com/vi/"+video.videoID+"/mqdefault.jpg"} height="50" onClick={onQueue} style={{cursor: "pointer"}}/></td>
                <td><p>{video.title}</p></td>
            </tr></table>


        </div>

    )
}

export default HistoryVideo;